import { operatorClient, shippingClient } from 'domain/HttpClients';
// import { getSelectedProfileFromStorage } from 'domain/fuse/auth/profiles/utils';
// import { shippingClient } from '../../mockClient';

export const start = (manifestOrderId) => shippingClient.Post(`/api/manifest/order/${manifestOrderId}/start-manifesting`).send();

export const createMW = (data) => shippingClient
  .Post('/api/manifest/create-mw')
  .withData(data)
  .send();

export const createManifestAndMW = (manifestOrderId, data) => shippingClient
  .Post(`/api/manifest/order/${manifestOrderId}/add-manifest-and-mw`)
  .withData(data)
  .send();
